<div class="fixed-contact-buttons tw-bg-white tw-p-2">
  <a href="https://about.dealers-stock.jp/osagashi" target="_blank">
    <div class="consultant-image">
      <img src="/assets/images/contact-buttons/contact-consultant.png" alt="コンサルタント" />
    </div>

    <div class="consultant-message tw-text-secondary">
      お探しの作品が<br />
      ある方はコチラ
    </div>
  </a>

  <a href="tel:03-4500-1497" class="contact-button tw-rounded">
    <img src="/assets/images/contact-buttons/phone.png" alt="電話" class="button-icon" />
    <span class="button-text">電話から</span>
  </a>

  <a href="https://about.dealers-stock.jp/osagashi#contact-form" target="_blank" class="contact-button tw-rounded">
    <img src="/assets/images/contact-buttons/form.png" alt="フォーム" class="button-icon" />
    <span class="button-text">フォームから</span>
  </a>

  <a href="https://line.me/R/ti/p/@502bbhkk" target="_blank" class="contact-button tw-rounded">
    <img src="/assets/images/contact-buttons/line.png" alt="LINE" class="button-icon" />
    <span class="button-text">LINEから</span>
  </a>
</div>
